export default __webpack_public_path__ + "static/media/display_contemporaryV2.245d1efd.png";